
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 111.2 86.2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.1 24.7h3.6V39H.1zM14.2 35.5h4.9V39h-8.5V24.7h3.6zM26.6 39.3a7.4 7.4 0 01-5.3-2.1 7.49 7.49 0 01-2.2-5.3 6.75 6.75 0 012.2-5.3 7.5 7.5 0 0112.8 5.2v.1a7.36 7.36 0 01-7.3 7.4zm0-3.6a3.63 3.63 0 003.8-3.6v-.2a4 4 0 00-3.9-3.9 3.86 3.86 0 00-2.7 1.1 3.93 3.93 0 00-1.1 2.8 3.72 3.72 0 003.6 3.9.37.37 0 01.3-.1zM38.5 39l-4.6-14.3h4l2.8 9.8 2.8-9.8h4L42.8 39zM52.2 35.5h5.5V39h-9.1V24.7h9v3.4h-5.4v2h4.9v3.4h-4.9zM27.2 63.4l-.6-2.1h-4.7l-.6 2.1h-3.9L22 49.1h4.4l4.7 14.2h-3.9zm-4.4-5.2h2.9l-1.4-4.8zM37.9 49.1a6.56 6.56 0 014.9 2 7.31 7.31 0 010 10.1 6.56 6.56 0 01-4.9 2h-5.8V49.1zm0 10.7a3.1 3.1 0 002.4-1 3.61 3.61 0 00.9-2.6 3.92 3.92 0 00-.9-2.6 3.1 3.1 0 00-2.4-1h-2v7.2zM54.7 63.4l-.6-2.1h-4.7l-.6 2.1h-3.9l4.7-14.2H54l4.7 14.2zm-4.4-5.2h2.9l-1.5-4.8zM65.2 49.1a5 5 0 013.6 8.6 5.43 5.43 0 01-3.6 1.4h-1.9v4.3h-3.6V49.1zm0 6.5a1.45 1.45 0 001.5-1.4v-.1a1.45 1.45 0 00-1.4-1.5h-2v3zM81.4 49.1v3.5h-3.5v10.7h-3.6V52.7h-3.5v-3.5h10.6zM82.7 49.1h3.6v14.2h-3.6zM92 63.4l-4.6-14.2h4l2.8 9.8 2.8-9.8h4l-4.6 14.2zM105.7 59.9h5.5v3.4h-9.1V49.1h9v3.4h-5.4v2h4.9v3.3h-4.9z","fill":"currentColor"}}),_c('path',{attrs:{"fill":"#80d823","d":"M86.3 38.2h-3.7V3.6h-79v10.9H0V0h86.3v38.2zM86.3 86.2H0V48h3.6v34.6h79V71.7h3.7v14.5z"}})])
          )
        }
      }
    